export const searchTooltipText = 'Search by version';
export const searchPlaceholderText = 'Search by version';
